export default (listToGroup: any[], propertyToGroup: string, cF?: () => void): any[] => {
  const groupedList: any[] = [];
  listToGroup.forEach((element: any) => {
    groupedList.push({ header: element.name });
    element[propertyToGroup].forEach((innerElement: any) => {
      groupedList.push({ id: innerElement.id, name: innerElement.name });
      if (!!cF) { cF(); }
    });
  });
  return groupedList;
};
